<!-- Modal backdrop — teleported to document.body so parent transforms cannot clip it -->
@if (isOpen) {
<div #overlay
  class="fixed inset-0 left-0 top-0 z-50 flex h-[100dvh] w-screen max-w-none items-center justify-center bg-black/50 backdrop-blur-sm px-4"
  (click)="onBackdropClick()">

  <!-- Modal content -->
  <div [ngClass]="modalSize"
    class="relative mx-auto flex max-h-[90vh] w-full max-w-full flex-col overflow-hidden rounded-2xl bg-white p-6 shadow-lg"
    (click)="$event.stopPropagation()">

    <!-- Close button -->
    @if(isCloseBtnShow){
    <button type="button" class="absolute top-3 right-3 cursor-pointer text-gray-500 hover:text-gray-700"
      (click)="onClose()">
      ✕
    </button>
    }

    @if (title) {
    <h2 class="mb-4 text-center text-lg font-semibold text-gray-800">
      {{ title }}
    </h2>
    }

    <!-- Body must flex & scroll -->
    <div class="modal-body flex-1 overflow-x-hidden overflow-y-auto text-sm text-gray-700 scrollbar-hide">
      <ng-content></ng-content>
    </div>

    <div class="mt-6">
      <ng-content select="[modal-footer]"></ng-content>
    </div>

  </div>

</div>
}
